'use client';

import { Add } from '@mui/icons-material';
import { Box, IconButton, ListItem, ListItemButton } from '@mui/material';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { MenuItemType } from './interfaces';
import { isPlainNavigationItem, NavigationItem } from './leftNavigationHelpers';

export function NavigateItemNext({ navigationItem }: { navigationItem: NavigationItem }) {
  const pathname = usePathname();

  if (navigationItem.type === MenuItemType.DIVIDER) {
    return <Box component="hr" sx={{ my: '2px' }} />;
  }

  const isActive = !!(navigationItem?.matchPaths || []).find((path) => pathname?.includes(path));
  const mainLink = navigationItem.link;

  if (isPlainNavigationItem(navigationItem) && navigationItem.addButtonLink) {
    const addButtonLink = navigationItem.addButtonLink.replace('/admin', '/site-admin');

    return (
      <ListItem sx={{ bgcolor: isActive ? (theme) => theme.palette.background.paper : 'initial', p: 0 }}>
        <ListItemButton LinkComponent={Link} href={mainLink} sx={{ pl: 1, py: 0.5 }}>
          {navigationItem.label}
        </ListItemButton>
        <Box component="hr" sx={{ width: '2px', height: '28px', my: 0 }} />
        <IconButton
          aria-label={navigationItem.addButtonLabel}
          LinkComponent={Link}
          href={addButtonLink}
          sx={{ borderRadius: 0 }}
          size="small"
          disabled={navigationItem.addButtonDisabled}
        >
          <Add color="primary" />
        </IconButton>
      </ListItem>
    );
  }

  return (
    <ListItem sx={{ bgcolor: isActive ? (theme) => theme.palette.background.paper : 'initial', p: 0 }}>
      <ListItemButton LinkComponent={Link} href={mainLink} sx={{ pl: 1, py: 0.5 }}>
        {navigationItem.label}
      </ListItemButton>
    </ListItem>
  );
}
